var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"app":""}},[_c('div',{staticClass:"d-flex justify-center align-center",style:({width: '100%', height: '100%'})},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"accent","indeterminate":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }